// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"31947f24","739":"9c6bc772"}[chunkId] + ".chunk.js";
};